import { helper } from '@ember/component/helper';

import { getOrElse } from '../utils/object-utils';

export function orElse<L, R>([value, elseValue]: [L | undefined, R]): L extends undefined ? R : L {
  return getOrElse(value, elseValue);
}

const orElseHelper = helper(orElse);
export default orElseHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'or-else': typeof orElseHelper;
  }
}
